module.exports = __webpack_public_path__ + "static/media/ic-zoom-out-grey.ee5feafc.svg";